import { PIPELINE_TYPE_LABELS, type PipelineType } from '../../../types/api.js';

export interface PipelineTypeBadgeProps {
  /** パイプラインタイプ */
  type: PipelineType;
}

/** @graph-connects none */
const typeStyles: Record<PipelineType, string> = {
  database: 'bg-[var(--color-info-muted)] text-[var(--color-info)]',
  mongodb: 'bg-[var(--color-success-muted)] text-[var(--color-success)]',
  jobcan: 'bg-[var(--color-accent-muted)] text-[var(--color-accent-primary)]',
  spreadsheet_sync: 'bg-[var(--color-warning-muted)] text-[var(--color-warning)]',
  drive: 'bg-[var(--color-bg-elevated)] text-[var(--color-text-secondary)]',
};

/**
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business パイプラインタイプバッジ。database=青、mongodb=緑、jobcan=紫、sheet=橙、drive=グレーで色分け
 * @graph-connects none
 */
export function PipelineTypeBadge({ type }: PipelineTypeBadgeProps) {
  return (
    <span
      className={`
        inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium
        ${typeStyles[type]}
      `}
    >
      {PIPELINE_TYPE_LABELS[type]}
    </span>
  );
}
